import {Directive, ElementRef} from '@angular/core';

// Run on all images that do not already have the loading attribute set
@Directive({
  selector: 'img:not([loading])'
})
export class LazyImageDirective {
  constructor({nativeElement}: ElementRef<HTMLImageElement>) {
    const supports = 'loading' in HTMLImageElement.prototype;

    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }
  }
}
